import { render, staticRenderFns } from "./sku.vue?vue&type=template&id=51136b9f&"
import script from "./sku.vue?vue&type=script&lang=js&"
export * from "./sku.vue?vue&type=script&lang=js&"
import style0 from "./sku.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports